(() => {
  const initializedSections = new WeakSet();
  const mobileContainers = new Set();
  let resizeBound = false;

  function initSwipers(scope) {
    scope.querySelectorAll('.swiper').forEach(swiperEl => {
      if (swiperEl.classList.contains('swiper-initialized')) return;

      const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
      const isGroup = swiperEl.classList.contains('mySwipergroup');
      const canLoop = isGroup ? slidesCount > 1 : slidesCount > 3;

      const controlScope = swiperEl.closest('.tab-panel') || swiperEl.closest('section') || scope;
      const prevBtn = controlScope.querySelector('.arrow.prev');
      const nextBtn = controlScope.querySelector('.arrow.next');

      new Swiper(swiperEl, {
        observer: true,
        observeParents: true,
        slidesPerView: isGroup ? 1 : 3,
        spaceBetween: isGroup ? 40 : 20,
        speed: 800,
        loop: canLoop,
        autoplay: canLoop
          ? {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: isGroup
          ? undefined
          : {
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            },
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
      });
    });
  }

  function initTabs(scope) {
    scope.querySelectorAll('.tabs-nav').forEach(tabsNav => {
      if (tabsNav.dataset.tabsInitialized === 'true') return;
      tabsNav.dataset.tabsInitialized = 'true';

      const section = tabsNav.closest('section');
      if (!section) return;

      const tabButtons = tabsNav.querySelectorAll('[data-tab-btn]');
      const tabPanels = section.querySelectorAll('.tabs-content .tab-panel');

      if (!tabButtons.length || !tabPanels.length) return;

      tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.tabBtn;

          tabButtons.forEach(b => b.classList.remove('active'));
          tabButtons.forEach(b => {
            if (b.dataset.tabBtn === key) {
              b.classList.add('active');
            }
          });

          tabPanels.forEach(panel => {
            panel.classList.toggle('active', panel.dataset.tabPanel === key);
          });

          const activePanel = section.querySelector(`.tab-panel[data-tab-panel="${key}"]`);
          activePanel?.querySelectorAll('.swiper').forEach(sw => {
            if (!sw.swiper) return;
            requestAnimationFrame(() => {
              sw.swiper.updateSize();
              sw.swiper.updateSlides();
              sw.swiper.update();
            });
          });
        });
      });
    });
  }

  function initProductCards(scope) {
    scope.querySelectorAll('[data-product-card]').forEach(card => {
      if (card.dataset.productCardInitialized === 'true') return;
      card.dataset.productCardInitialized = 'true';

      const optionsWrap = card.querySelector('[data-product-card-options]');
      const priceEl = card.querySelector('[data-product-card-price]');
      const compareEl = card.querySelector('[data-product-card-compare]');

      if (!optionsWrap || !priceEl) return;

      const optionButtons = Array.from(optionsWrap.querySelectorAll('[data-option-value]'));
      if (!optionButtons.length) return;

      let variants = [];
      try {
        variants = JSON.parse(card.dataset.variants || '[]');
      } catch (error) {
        variants = [];
      }

      if (!variants.length) return;

      const optionPosition = Number(card.dataset.cardOptionPosition || 1);
      const optionKey = `option${optionPosition}`;

      function findMatchingVariant(optionValue) {
        return (
          variants.find(variant => variant.available && variant[optionKey] === optionValue) ||
          variants.find(variant => variant[optionKey] === optionValue) ||
          null
        );
      }

      function updateCardState(selectedValue) {
        const matchedVariant = findMatchingVariant(selectedValue);
        if (!matchedVariant) return;

        optionButtons.forEach(button => {
          const isActive = button.dataset.optionValue === selectedValue;
          button.classList.toggle('active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        priceEl.textContent = matchedVariant.price_formatted || priceEl.textContent;

        if (compareEl) {
          const hasComparePrice = Number(matchedVariant.compare_at_price) > Number(matchedVariant.price);
          compareEl.hidden = !hasComparePrice;
          compareEl.textContent = hasComparePrice ? matchedVariant.compare_at_price_formatted : '';
        }
      }

      const activeButton = optionButtons.find(button => button.classList.contains('active')) || optionButtons[0];
      if (activeButton) {
        updateCardState(activeButton.dataset.optionValue);
      }

      optionButtons.forEach(button => {
        button.addEventListener('click', () => {
          updateCardState(button.dataset.optionValue);
        });
      });
    });
  }

  function registerMobileContainer(container, wrapperSelector, slideSelector, options) {
    if (container.dataset.mobileSwiperInitialized === 'true') return;
    container.dataset.mobileSwiperInitialized = 'true';
    const activationQuery = options.activationQuery || '(max-width: 767px)';
    delete options.activationQuery;
    container._cloudySwiperConfig = {
      wrapperSelector,
      slideSelector,
      options: {
        observer: true,
        observeParents: true,
        ...options,
      },
      activationQuery,
    };
    mobileContainers.add(container);
  }

  function initMobileSwipers(scope) {
    scope.querySelectorAll('.productmobileslider').forEach(container => {
      registerMobileContainer(container, '.ps-card-wraper', '.product-item', {
        slidesPerView: 1.1,
        spaceBetween: 12,
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
    });

    scope.querySelectorAll('.plushcardmain').forEach(container => {
      registerMobileContainer(container, '.plushcardmainwraper', '.plush-card', {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });
    });

    scope.querySelectorAll('.LogoProductGrid__cardsResponsive').forEach(container => {
      const tabletSlides = Math.max(1, Number(container.dataset.slidesTablet || 2));
      const mobileSlides = Math.max(1, Number(container.dataset.slidesMobile || 1));
      const slidesCount = container.querySelectorAll('.LogoProductGrid__responsiveSlide').length;
      const canLoop = slidesCount > Math.max(tabletSlides, mobileSlides);

      registerMobileContainer(container, '.LogoProductGrid__responsiveTrack', '.LogoProductGrid__responsiveSlide', {
        slidesPerView: mobileSlides,
        spaceBetween: 18,
        speed: 600,
        loop: canLoop,
        autoplay: canLoop
          ? {
              delay: 2800,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: tabletSlides,
            spaceBetween: 22,
          },
        },
        activationQuery: '(max-width: 1024px)',
      });
    });

    scope.querySelectorAll('.product-showcase-responsive-slider').forEach(container => {
      const tabletSlides = Math.max(1, Number(container.dataset.slidesTablet || 2));
      const mobileSlides = Math.max(1, Number(container.dataset.slidesMobile || 1));
      const tabletRows = Math.max(1, Number(container.dataset.rowsTablet || 1));
      const mobileRows = Math.max(1, Number(container.dataset.rowsMobile || 1));
      const slidesCount = container.querySelectorAll('.product-showcase-responsive-slide').length;
      const canLoop = slidesCount > Math.max(tabletSlides * tabletRows, mobileSlides * mobileRows);
      const usesMultiRow = tabletRows > 1 || mobileRows > 1;
      const enableLoop = canLoop && !usesMultiRow;

      registerMobileContainer(container, '.product-showcase-responsive-track', '.product-showcase-responsive-slide', {
        slidesPerView: mobileSlides,
        slidesPerGroup: mobileSlides,
        spaceBetween: 16,
        speed: 700,
        loop: enableLoop,
        grid: {
          rows: mobileRows,
          fill: 'row',
        },
        autoplay: enableLoop
          ? {
              delay: 3200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView: tabletSlides,
            slidesPerGroup: tabletSlides,
            spaceBetween: 18,
            grid: {
              rows: tabletRows,
              fill: 'row',
            },
          },
        },
        activationQuery: '(max-width: 991px)',
      });
    });

    handleMobileSwipers();

    if (!resizeBound) {
      resizeBound = true;
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleMobileSwipers, 150);
      });
    }
  }

  function handleMobileSwipers() {
    mobileContainers.forEach(container => {
      if (!document.body.contains(container)) {
        if (container._cloudySwiper) {
          container._cloudySwiper.destroy(true, true);
          container._cloudySwiper = null;
        }
        mobileContainers.delete(container);
        return;
      }

      const config = container._cloudySwiperConfig;
      if (!config) return;
      const shouldActivate = window.matchMedia(config.activationQuery).matches;

      const wrapper = container.querySelector(config.wrapperSelector);
      const slides = container.querySelectorAll(config.slideSelector);

      if (!wrapper || !slides.length) return;

      if (shouldActivate) {
        container.classList.add('swiper');
        wrapper.classList.add('swiper-wrapper');
        slides.forEach(slide => slide.classList.add('swiper-slide'));

        if (!container._cloudySwiper) {
          container._cloudySwiper = new Swiper(container, config.options);
        }
      } else {
        if (container._cloudySwiper) {
          container._cloudySwiper.destroy(true, true);
          container._cloudySwiper = null;
        }
        container.classList.remove('swiper');
        wrapper.classList.remove('swiper-wrapper');
        slides.forEach(slide => slide.classList.remove('swiper-slide'));
      }
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl || initializedSections.has(sectionEl)) return;
    initializedSections.add(sectionEl);

    initSwipers(sectionEl);
    initTabs(sectionEl);
    initProductCards(sectionEl);
    initMobileSwipers(sectionEl);
  }

  function destroySection(sectionEl) {
    if (!sectionEl) return;
    initializedSections.delete(sectionEl);
    sectionEl.querySelectorAll('.swiper').forEach(sw => {
      if (sw.swiper) {
        sw.swiper.destroy(true, true);
      }
    });
  }

  function initSearchModal() {
    const modal = document.querySelector('[data-search-modal]');
    if (!modal) return;

    const toggles = document.querySelectorAll('[data-search-toggle]');
    const closeButtons = modal.querySelectorAll('[data-search-close]');
    const input = modal.querySelector('[data-search-input]');
    const results = modal.querySelector('[data-search-results]');
    const status = modal.querySelector('[data-search-status]');
    const viewAll = modal.querySelector('[data-search-view-all]');
    const suggestUrl = modal.dataset.searchSuggestUrl || '/search/suggest.json';
    const searchUrl = modal.dataset.searchUrl || '/search';

    if (!input || !results || !viewAll || !status) return;

    let debounceTimer = null;
    let lastQuery = '';

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-open');
      input.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-open');
    }

    function setStatus(message) {
      status.textContent = message || '';
    }

    function clearResults() {
      results.innerHTML = '';
      setStatus('');
    }

    async function fetchResults(query) {
      const url = `${suggestUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor`;
      const response = await fetch(url, {
        headers: { 'Accept': 'application/json' },
      });
      if (!response.ok) throw new Error('Search failed');
      return response.json();
    }

    function renderResults(payload) {
      const products = payload?.resources?.results?.products || [];
      results.innerHTML = '';

      if (!products.length) {
        setStatus('No results found.');
        return;
      }

      setStatus(`${products.length} result${products.length === 1 ? '' : 's'} found`);

      products.forEach(product => {
        const item = document.createElement('a');
        item.className = 'search-result-item';
        item.href = product.url || '#';

        const image = product.image ? `<img src="${product.image}" alt="${product.title || ''}">` : '';
        const vendor = product.vendor ? `<div class="search-result-meta">${product.vendor}</div>` : '';

        item.innerHTML = `${image}<div><div class="search-result-title">${product.title || 'Untitled product'}</div>${vendor}</div>`;
        results.appendChild(item);
      });
    }

    function updateViewAllLink(query) {
      const url = query ? `${searchUrl}?q=${encodeURIComponent(query)}` : searchUrl;
      viewAll.setAttribute('href', url);
    }

    function onInput() {
      const query = input.value.trim();
      updateViewAllLink(query);

      if (query.length < 2) {
        clearResults();
        return;
      }

      if (query === lastQuery) return;
      lastQuery = query;

      setStatus('Searching...');

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        try {
          const data = await fetchResults(query);
          renderResults(data);
        } catch (error) {
          setStatus('Search failed. Please try again.');
        }
      }, 250);
    }

    toggles.forEach(toggle => {
      if (toggle.dataset.searchToggleBound === 'true') return;
      toggle.dataset.searchToggleBound = 'true';
      toggle.addEventListener('click', event => {
        event.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach(btn => {
      if (btn.dataset.searchCloseBound === 'true') return;
      btn.dataset.searchCloseBound = 'true';
      btn.addEventListener('click', closeModal);
    });

    if (modal.dataset.searchModalBound !== 'true') {
      modal.dataset.searchModalBound = 'true';
      modal.addEventListener('click', event => {
        if (event.target.matches('[data-search-close]')) {
          closeModal();
        }
      });
    }

    if (document.body.dataset.searchEscapeBound !== 'true') {
      document.body.dataset.searchEscapeBound = 'true';
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }

    if (input.dataset.searchInputBound !== 'true') {
      input.dataset.searchInputBound = 'true';
      input.addEventListener('input', onInput);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(initSection);
    initProductCards(document);
    initSearchModal();
  });

  document.addEventListener('shopify:section:load', event => {
    const sectionEl = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    initSection(sectionEl);
    initSearchModal();
  });

  document.addEventListener('shopify:section:unload', event => {
    const sectionEl = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    destroySection(sectionEl);
  });
})();
